import { FC, useState } from 'react';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import { PaginationController } from '../../../../components/pagination-controller/index';
import { EventHooks, useFormat } from '../../../../hooks/index';
import { BuybackEventItem, eventFormType, EventTypeBackend } from '../../../../types/events.types';
import { CardProps } from './transaction-card-variants.types';
import { TransactionOverviewItem } from './transaction-overview-item';
import { TransactionTitleItem } from './transaction-title-item';

export const Buyback: FC<CardProps> = ({ event, companyId }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const { format } = useFormat();
  const { items, totalPages } = EventHooks.useTransactions<BuybackEventItem>({
    eventId: event.id,
    eventType: EventTypeBackend.BUYBACK,
    companyId: companyId,
    currentPage,
  });

  if (event.type !== EventTypeBackend.BUYBACK) return <></>;
  const { type } = event;
  return (
    <>
      {items.map(({ date, shareClass, sharesCount, stakeholder }, i) => (
        <div
          className="flex flex-col divide-y divide-gray-100 rounded-md shadow-sm"
          key={i + shareClass.id}
        >
          <TransactionTitleItem
            createdAt={format(date, 'dd/MM/yyyy')}
            name={stakeholder?.fullName}
          />
          <TransactionOverviewItem
            title={<AppFormattedMessage id="TRANSACTION_TYPE" />}
            value={<AppFormattedMessage id={eventFormType[type]} />}
          />
          <TransactionOverviewItem
            title={<AppFormattedMessage id="INVESTMENTS" />}
            value={shareClass.name}
          />
          <TransactionOverviewItem
            title={<AppFormattedMessage id="NO_OF_SHARES" />}
            value={sharesCount.toLocaleString('en-US')}
          />
        </div>
      ))}
      <PaginationController
        className="mt-6 shrink-0"
        currentPage={currentPage}
        onClick={setCurrentPage}
        totalPages={totalPages}
      />
    </>
  );
};
